/* loop-mini.js
   Extraído de snippets/product-card.liquid em 13/mai/2026.
   Antes: ~140 linhas <script> inline com {{ product.id }} placeholders, renderizadas N× por card.
   Agora: 1× cacheado no CDN. Identifica elementos via querySelector scoped no card (não usa IDs Liquid).

   Requer no <head>:
     window.LoopMiniConfig = { moneyFormat: "...", currency: "USD" };
*/
(function () {
  if (window.__LOOP_MINI_INITED__) return;
  window.__LOOP_MINI_INITED__ = true;

  var cfg = window.LoopMiniConfig || {};
  var moneyFormat = cfg.moneyFormat || '${{amount}}';
  var currency = cfg.currency || 'USD';

  function fmt(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }

  function initCard(card) {
    if (card.dataset.loopMiniInited) return;

    var wrap = card.querySelector('.js-loop-mini');
    if (!wrap) return;

    var form = card.querySelector('form.js-product-form-main') || card.querySelector('form.js-product-form');
    if (!form) return;

    card.dataset.loopMiniInited = '1';

    // Identifica elementos por value/class (scope no card), não por ID com {{ product.id }}
    var ot = wrap.querySelector('input[type="radio"][value="ot"]');
    var sub = wrap.querySelector('input[type="radio"][value="sub"]');
    var sel = wrap.querySelector('select.selling_plan_product');
    var otPriceEl = wrap.querySelector('.ot-price');
    var subPriceEl = wrap.querySelector('.sub-price');
    var saveEl = wrap.querySelector('.js-save');
    var saveCentsWrap = wrap.querySelector('.js-save-cents');
    var saveCentsValueEl = wrap.querySelector('.js-save-cents-value');
    var subBlock = wrap.querySelector('.purchase_option.sub');
    var subLabelEl = wrap.querySelector('.sub-label');

    // FIX (18/mai/2026): garantir One-time como default no init, mesmo se o
    // browser preservou state via bfcache/restore ou se o markup foi cacheado
    // antes do fix do Liquid. O cliente quer SEMPRE começar com One-time.
    if (ot && sub) {
      sub.checked = false;
      ot.checked = true;
    }

    // Elementos fora do wrap-subscription mas dentro do card:
    var priceTotalEl = card.querySelector('.price--top .price__total, .price--bottom .price__total');
    var atcPriceEl = card.querySelector('.atc-price');

    // O JSON de planos é renderizado por card. Procura dentro do card.
    var plansJsonEl = card.querySelector('script[type="application/json"][data-loop-plans]');
    var planData = plansJsonEl ? JSON.parse(plansJsonEl.textContent) : { variants: {} };

    function getCurrentVariantId() {
      var idInput = form.querySelector('input[name="id"]');
      return idInput ? idInput.value : '';
    }

    function syncSellingPlanName() {
      if (!sel) return;
      if (sub && sub.checked) {
        sel.disabled = false;
        sel.name = 'selling_plan';
      } else {
        sel.disabled = true;
        sel.name = '';
      }
    }

    // Retorna o preço (cents) selecionado no momento: OT ou Sub conforme radios.
    function getSelectedPriceCents(v) {
      if (!v) return null;
      var isSub = sub && sub.checked && !sub.disabled && v.plans && v.plans.length;
      if (!isSub) return v.price;
      var chosen = null;
      if (sel && sel.value) {
        chosen = v.plans.find(function (p) { return String(p.id) === String(sel.value); });
      }
      if (!chosen) chosen = v.plans[0];
      return (chosen && chosen.price != null) ? chosen.price : v.price;
    }

    // Atualiza o preço total mostrado no topo do card e o preço do botão ATC.
    function refreshSelectedPriceDisplays() {
      var vid = getCurrentVariantId();
      var v = planData.variants[vid];
      var price = getSelectedPriceCents(v);
      if (price == null) return;
      var formatted = fmt(price);
      if (priceTotalEl) priceTotalEl.textContent = formatted;
      if (atcPriceEl) atcPriceEl.textContent = formatted;
    }

    function refreshSubUi() {
      var vid = getCurrentVariantId();
      var v = planData.variants[vid];

      if (v && typeof v.price === 'number') {
        if (otPriceEl) otPriceEl.textContent = fmt(v.price);
      }

      if (!v || !v.plans || !v.plans.length) {
        if (subBlock) subBlock.style.display = 'none';
        if (sub) sub.checked = false;
        if (ot) ot.checked = true;
        if (sel) { sel.disabled = true; sel.name = ''; sel.innerHTML = ''; }
        if (saveCentsWrap) saveCentsWrap.style.display = 'none';
        refreshSelectedPriceDisplays();
        return;
      }

      if (subBlock) subBlock.style.display = '';
      if (sel) {
        sel.innerHTML = '';
        v.plans.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p.id;
          opt.textContent = p.name;
          sel.appendChild(opt);
        });
      }

      var subPrice = (v.plans[0].price != null ? v.plans[0].price : v.price);
      if (subPriceEl) subPriceEl.textContent = fmt(subPrice);

      var saveCents = v.price - subPrice;
      var savePct = (v.price > 0) ? Math.round(saveCents * 100 / v.price) : 0;

      if (saveEl) {
        if (savePct > 0) {
          saveEl.textContent = savePct;
          if (saveEl.parentElement) saveEl.parentElement.style.display = '';
        } else if (saveEl.parentElement) {
          saveEl.parentElement.style.display = 'none';
        }
      }

      if (saveCentsWrap) {
        if (saveCents > 0) {
          saveCentsWrap.style.display = '';
          if (saveCentsValueEl) saveCentsValueEl.textContent = fmt(saveCents);
        } else {
          saveCentsWrap.style.display = 'none';
        }
      }

      if (subLabelEl) subLabelEl.classList.toggle('sub-label--with-save', saveCents > 0);

      syncSellingPlanName();
      refreshSelectedPriceDisplays();
    }

    card.addEventListener('change', function (e) {
      if (e.target === ot || e.target === sub) {
        syncSellingPlanName();
        refreshSelectedPriceDisplays();
        return;
      }
      if (e.target.classList && e.target.classList.contains('js-option') || (e.target.closest && e.target.closest('.option-selector__btns'))) {
        setTimeout(refreshSubUi, 0);
      }
      if (e.target === sel) {
        var vid = getCurrentVariantId();
        var v = planData.variants[vid];
        if (v && v.plans && v.plans.length) {
          var chosen = v.plans.find(function (p) { return String(p.id) === String(sel.value); }) || v.plans[0];
          var subPrice = (chosen.price != null ? chosen.price : v.price);
          if (subPriceEl) subPriceEl.textContent = fmt(subPrice);
          var saveCents = v.price - subPrice;
          var savePct = (v.price > 0) ? Math.round(saveCents * 100 / v.price) : 0;
          if (saveEl) {
            if (savePct > 0) {
              saveEl.textContent = savePct;
              if (saveEl.parentElement) saveEl.parentElement.style.display = '';
            } else if (saveEl.parentElement) {
              saveEl.parentElement.style.display = 'none';
            }
          }
          if (saveCentsWrap) {
            if (saveCents > 0) {
              saveCentsWrap.style.display = '';
              if (saveCentsValueEl) saveCentsValueEl.textContent = fmt(saveCents);
            } else {
              saveCentsWrap.style.display = 'none';
            }
          }
          if (subLabelEl) subLabelEl.classList.toggle('sub-label--with-save', saveCents > 0);
          refreshSelectedPriceDisplays();
        }
      }
    });

    refreshSubUi();
    syncSellingPlanName();
  }

  function initAll() {
    document.querySelectorAll('product-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init quando o cart é atualizado (caso novos cards sejam injetados via Section Rendering)
  document.addEventListener('cart:updated', initAll);
})();
